import React from 'react';

export interface WorkflowContextProps {
  workflowId?: number;
  valuesDst?: string;
  workflowReducerScope?: string[];
  currentStepName?: string;
}

const WorkflowContext = React.createContext<WorkflowContextProps>({});

export default WorkflowContext;
